import React, { useEffect, useState, useMemo, useContext } from 'react';
// @ts-ignore
import { USBLink } from '@usb-shield/components-react';

import moment from 'moment';
import { getRequirementsRequirements, getDefaultFilters } from './utils';
import RequirementsFilters from './RequirementsFilters';
import RequirementsTable from './RequirementsTable';
import Pagination from './Pagination';
import { USBIconDownload, USBIconPeople } from '@usb-shield/react-icons';
import './requirementsstyle.scss';
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import actionlogo from '../../assets/images/rightArrow.png';
import { FeatureFlagsContext } from '../../components/Hooks/useFeatureFlags';
import { getValueByNestedKey } from './utils';
import Loader from '../../components/utilities/Loader';

function Requirements() {

  // // Retrieve the object from session storage
  // const storedObject = JSON.parse(sessionStorage.getItem('defaultFilters')) || {};

  // // Transform the object
  // const transformedObject = Object.keys(storedObject).reduce((acc, key) => {
  //     const { label, value } = storedObject[key];
  //     acc[label] = value;
  //     return acc;
  // }, {});

  const [status, setStatus] = useState({ loading: true, error: null });
  const [requirements, setRequirements] = useState(null);
  const [categories, setCategories] = useState(null);
  const [filters, setFilters] = useState(getDefaultFilters());
  const [opneModel, setOpenModel] = useState(false)
  const [requirementID, setRequirementId] = useState('');
  const [reqStatus, setReqStatus] = useState("Status");
  const [reqCategory, setReqCategory] = useState("");
  const [reqDealId, setReqDealId] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const { featureDetails } = useContext(FeatureFlagsContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [requirementsPerPage, setRequirementsPerPage] = useState(25);

  async function fetchData() {
    await setStatus((prevStatus) => ({ ...prevStatus, loading: true }));
    await getRequirementsRequirements({ setRequirements, setTotalCount, setCategories, setStatus, reqCategory, reqStatus, reqDealId, currentPage, requirementsPerPage });
    await setStatus({ loading: false, error: status.error });
  }

  let timer;


  useEffect(() => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fetchData();
    }, 2000);
    return () => clearTimeout(timer);
    // console.log(requirements)
  }, [reqDealId, reqStatus, currentPage, reqCategory]);


  useEffect(() => {
    if (featureDetails?.length > 0) {
      if (!featureDetails?.includes("feature_requirements_visible")) {
        window.location.href = "/Redirect";
      }
    }
  }, [featureDetails])

  // const filteredRequirements = useMemo(() => {
  //   console.log(requirements)
  //   return [...requirements].sort((a, b) => {
  //     const valueA = getValueByNestedKey(a, "dueDate");
  //     const valueB = getValueByNestedKey(b, "dueDate");
  //     if (valueA < valueB) {
  //       return  -1 ;
  //     } else if (valueA > valueB) {
  //       return 1 ;
  //     }
  //     return 0;
  //   });
  // }, [filters, requirements]);

  const filteredRequirements = useMemo(() => {
    return requirements?.filter((item) =>
      Object.entries(filters).every(([key, obj]) => {
        if (key === 'status' && obj?.label === 'Show All' && obj?.value === 'Status') {
          return true;
        }
        const keys = key.split('.');
        return (
          keys.reduce((acc, current) => acc && acc[current], item)?.substring(0, obj?.value?.length) === obj?.value || keys.reduce((acc, current) => acc && acc[current], item)?.substring(0, obj?.value?.length) === moment(obj?.value).format('MM/DD/YYYY')
        );
      })
    );
  }, [requirements, currentPage]);

  const columns = [
    {
      label: 'Due Date',
      accessor: 'dueDate',
      sortable: true,

      cell: (row) => {
        const date = new Date(row.dueDate);
        return <>{date.toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        })}</>;
      },
      style: { width: '15%' },
    },
    {
      label: 'Deal ID',
      accessor: 'dealId',
      sortable: true,
      style: { width: '10%' },
    },
    {
      label: 'Deal Name',
      accessor: 'dealName',
      sortable: true,
      style: { width: '20%' },
    },

    {
      label: 'Parent Company',
      accessor: 'parentCompanyName',
      sortable: true,
      style: { width: '20%' },
    },

    {
      label: 'Document Type',
      accessor: 'category',
      style: { width: '15%' },
      sortable: true,
      cell: (row) => {
        return <>{row.category?.charAt(0).toUpperCase() + row.category?.slice(1)}</>;
      },
    },
    {
      label: 'Status',
      accessor: 'status',
      sortable: true,
      style: { width: '10%' },
    },


    {
      label: 'Open',
      accessor: '',
      cell: (row) => {
        return (
          <>
            <USBLink
              id={`open-requirement-${row.id}`}
              href={`FindByRequirementId?id=${row.id}`}
              linkType="basic"
            >
              <div className="expand-column-off">
                <img src={actionlogo}></img>
              </div>
            </USBLink>
          </>
        );
      },
      style: { width: '10%' },
    },
  ];
  function onCancel() {
    setOpenModel(false)
  }


  const paginate = pageNumber => setCurrentPage(pageNumber);

  const indexOfLastRequirement = currentPage * requirementsPerPage;
  const indexOfFirstRequirement = indexOfLastRequirement - requirementsPerPage;
  const currentRequirements = requirements?.slice(indexOfFirstRequirement, indexOfLastRequirement);



  const startIndex = (currentPage - 1) * requirementsPerPage;
  const endIndex = startIndex + requirementsPerPage;


  return (
    <section className="requirements-portfolio-container width-100">


      {featureDetails?.length > 0 && featureDetails?.includes("feature_requirements_visible") ?

        <section className="full-height">

          <USBBreadcrumb
            id="requirements"
            text="Requirements"
            breadcrumbs={[
              {
                id: 1,
                text: 'Tools',
                href: '/AllRequirements'
              },
              {
                id: 2,
                text: 'All Requirements',
                href: '/AllRequirements',
              },
            ]}
          />


          <h1 className="heading-h1 p-t-md">All Requirements</h1>
          <p className="secondary-text">
            You'll see all requirements irrespective of assigned user. Please type full Deal ID in text box to filter. Click on Open icon to navigate to requirement.
          </p>

          Total Requirements - <strong>{totalCount}</strong>
          {/* component for popup on screen  */}



          <RequirementsFilters
            requirements={requirements}
            reqDealId={reqDealId}
            filters={filters}
            setReqDealId={setReqDealId}
            setReqStatus={setReqStatus}
            reqCategory={reqCategory}
            setReqCategory={setReqCategory}
            setFilters={setFilters}
            setCurrentPage={setCurrentPage}
            setRequirements={setRequirements}
            categories={categories}
            setStatus={setStatus}
          ></RequirementsFilters>
          {totalCount > requirementsPerPage && (<>
            {/* Total Records - {totalCount} Total Page - {Math.ceil(totalCount / requirementsPerPage)} Current Page - {currentPage} */}
            <Pagination
              requirementsPerPage={requirementsPerPage}
              totalRequirements={totalCount}
              paginate={paginate} currentPage={currentPage}
            />
          </>)}
          {status.loading ? <Loader></Loader> : filteredRequirements?.length > 0 ? <RequirementsTable
            data={filteredRequirements?.sort((a, b) => {
              const valueA = getValueByNestedKey(a, "dueDate");
              const valueB = getValueByNestedKey(b, "dueDate");
              if (valueA < valueB) {
                return 1;
              } else if (valueA > valueB) {
                return -1;
              }
              return 0;
            }) || []}
            headers={columns}
            status={status}
            setStatus={setStatus}
            searchProperties={{
              enable: true,
              keys: [
                'dueDate',
                'dealId',
                'dealName',
                'parentCompanyName',
                'category',
                'status',
              ],
            }}
          ></RequirementsTable> : <div style={{
            textAlign: 'center', fontWeight: 'bold', width: '100%',
            border: '1px solid black',
            borderRadius: '8px',
            padding: '8px',
            marginBottom : '16px'
          }}>No requirements to display</div>}
          {/* page loader */}
          {/* @ts-ignore */}
          {/* {status.loading ? <Loader /> : null} */}
        </section>
        : ''}
    </section>
  );
}

export default Requirements;
